/* eslint-disable deprecation/deprecation */
import { Injectable } from '@angular/core';
import { CartActions, CartVoucherApiService } from '@cart/data-access';
import { EnvironmentService } from '@core/feature';
import { Actions, createEffect, EffectNotification, ofType } from '@ngrx/effects';
import { normalizeHttpError } from '@spartacus/core';
import { EMPTY, from, iif, Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class CustomCartVoucherEffects {
  addCartVoucher$: Observable<
    CartActions.CartVoucherAction | CartActions.LoadCart | CartActions.CartProcessesDecrement
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.CART_ADD_VOUCHER),
      map((action: CartActions.CartAddVoucher) => action.payload),
      mergeMap((payload) => {
        return this.occCartVoucherService.add(payload.userId, payload.cartId, payload.voucherId).pipe(
          map(() => {
            return new CartActions.CartAddVoucherSuccess({
              ...payload,
            });
          }),
          catchError((error) =>
            from([
              new CartActions.CartAddVoucherFail({
                ...payload,
                error: normalizeHttpError(error),
              }),
              new CartActions.CartProcessesDecrement(payload.cartId),
              new CartActions.LoadCart({
                userId: payload.userId,
                cartId: payload.cartId,
              }),
            ]),
          ),
        );
      }),
    ),
  );

  removeCartVoucher$: Observable<CartActions.CartVoucherAction | CartActions.LoadCart> = createEffect(() =>
    this.actions$.pipe(
      ofType(CartActions.CART_REMOVE_VOUCHER),
      map((action: CartActions.CartRemoveVoucher) => action.payload),
      mergeMap((payload) => {
        return this.occCartVoucherService.remove(payload.userId, payload.cartId, payload.voucherId).pipe(
          map(() => {
            return new CartActions.CartRemoveVoucherSuccess({
              userId: payload.userId,
              cartId: payload.cartId,
              voucherId: payload.voucherId,
            });
          }),
          catchError((error) =>
            from([
              new CartActions.CartRemoveVoucherFail({
                error: normalizeHttpError(error),
                cartId: payload.cartId,
                userId: payload.userId,
                voucherId: payload.voucherId,
              }),
              new CartActions.LoadCart({
                userId: payload.userId,
                cartId: payload.cartId,
              }),
            ]),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occCartVoucherService: CartVoucherApiService,
    private environmentService: EnvironmentService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(() => this.environmentService.isPlatformBrowser, resolvedEffects$, EMPTY);
  }
}
